const BASE = `${process.env.REACT_APP_ACTOR_API_URL || 'http://localhost:3001'}/simulations`;

function authHeaders(token, userId) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-user-id': userId,
  };
}

async function call(path, options = {}, token, userId) {
  const res  = await fetch(`${BASE}${path}`, { headers: authHeaders(token, userId), ...options });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Request failed');
  return json.data;
}

export const saveSimulation    = (body, token, userId) => call('',       { method: 'POST', body: JSON.stringify(body) }, token, userId);
export const listSimulations   = (token, userId)        => call('',       {}, token, userId);
export const deleteSimulation  = (id, token, userId)    => call(`/${id}`, { method: 'DELETE' }, token, userId);
export const getSimulationById = (id, token, userId)    => call(`/${id}`, {}, token, userId);
